import React from 'react';
import './Footer.css';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-brand">
            <img
              src="/total-logo.png"
              alt="Totalguard Workwear Rosslyn logo"
              className="footer-logo"
            />
            <div>
              <p className="footer-text">
                © {currentYear} Totalguard Workwear Rosslyn. All rights reserved.
              </p>
            </div>
          </div>
          
          <div className="footer-contact">
            <a href="tel:0123210060"> 012 321 0060</a>
            <a href="mailto:sales@totalguardppe.co.za"> sales@totalguardppe.co.za</a>
            <a href="https://wa.me/27616779840"> WhatsApp: 061 677 9840</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
